<template>
    <div class="wrapper landing-page">
        <div class="page-header page-header-small">
            <parallax class="page-header-image"
                 style="background-image: url('img/tjn-bck.jpg')">
            </parallax>
            <div class="content-center">
                <h1 class="title">{{webSiteBilgileri.SiteAdi}}</h1>
                <h5 class="description">{{webSiteBilgileri.Slogan}}</h5>
                <div class="text-center">
                    <a href="https://www.instagram.com/tijenhoca/" class="btn btn-primary btn-icon  btn-round">
                        <i class="fab fa-instagram"></i>
                    </a>
                    <a href="https://twitter.com/tijentangulse" class="btn btn-primary btn-icon btn-round">
                        <i class="fab fa-twitter"></i>
                    </a>
                    <a href="https://www.facebook.com/pages/Tijen-Hoca/208586643077901" class="btn btn-primary btn-icon btn-round">
                        <i class="fab fa-facebook"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="blogs-5" data-background-color="gray">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h2 class="title">Son Duyurular</h2>
                        <div class="row" v-if="duyurulars.length > 0">
                            <div class="row">
                                <div v-for="p in duyurulars.length < 4 ? duyurulars.length : 4" :key="p" class="col-md-4">
                                    <router-link  :to="'/duyuru/'+duyurulars[p - 1 ].id">
                                    <div class="card card-blog">
                                        <div style="min-height:300px" class="card-image">

                                                <img style="max-height: 400px" class="img rounded" :src="frontend_address + duyurulars[p - 1 ].Resim.url" >

                                        </div>
                                        <div class="card-body">
                                            <div>
                                                <h6 class="category text-primary">Duyuru</h6>
                                                <h5 class="card-title">
                                                    {{ duyurulars[p - 1 ].Baslik   }}
                                                </h5>
                                                <div class="card-footer">
                                                    <div class="author">
                                                        <img v-lazy="'img/tijen_tan_gulse.jpg'" alt="..." class="avatar img-raised">
                                                        <span>TİJEN TAN GÜLSE</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="features-4">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">Yaptığım bazı işler!</h2>
                        <h4 class="description">Öğrencilerime daha da faydalı olabilmek için yaptığım işlerin bir kısmı. </h4>
                    </div>
                </div>
                <div class="row" v-if="webSiteBilgileri.KatildigimIsler.length > 0">
                    <div v-for="k in webSiteBilgileri.KatildigimIsler" :key="k.id" class="col-md-4">
                        <a :href="k.link">
                            <card type="background" raised color="transparent" :style="{'min-height':'300px','background-image': 'url('+frontend_address + k.ArkaPlanResmi.url+' )'}">
                                <template slot="info">
                                    <div class="icon icon-white">
                                        <i :class="['now-ui-icons',k.icon]"></i>
                                    </div>
                                    <div class="description">
                                        <h4 class="info-title">{{k.Baslik}}</h4>
                                        <p>{{k.KisaAciklama}}</p>
    <!--                                    <a :href="k.link" class="ml-3">Daha Fazlası</a>-->
                                    </div>
                                </template>
                            </card>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="blogs-5" data-background-color="gray">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h2 class="title">Son Podcastler</h2>
                        <div class="row" v-if="podCasts.length > 0">
                            <div class="row">
                            <div v-for="p in podCasts.length < 5 ? podCasts.length : 5" :key="p" class="col-md-4">
                                <div class="card card-blog">
                                    <div class="card-image">
                                        <a href="#pablo">
                                            <img class="img rounded" :src="frontend_address + podCasts[p - 1 ].KapakResmi.url" >
                                        </a>
                                    </div>
                                    <div class="card-body">
                                        <router-link  :to="'/podcast/'+podCasts[p - 1 ].id">
                                            <h6 class="category text-primary">İngilizce Atölyesi</h6>
                                            <h5 class="card-title">
                                                {{ podCasts[p - 1 ].Adi   }}
                                            </h5>
                                            <p class="card-description">
                                               {{ podCasts[p - 1 ].KisaAciklama}}
                                            </p>
                                            <div class="card-footer">
                                                <div class="author">
                                                    <img v-lazy="'img/tijen_tan_gulse.jpg'" alt="..." class="avatar img-raised">
                                                    <span>TİJEN TAN GÜLSE</span>
                                                </div>
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput, Tabs, TabPane } from '@/components';
  import gql from "graphql-tag";
  export default {
    name: 'landing-page',
    bodyClass: 'landing-page',
    components: {
      Card,
      Tabs,
      TabPane,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        form: {
          firstName: '',
          email: '',
          message: '',
        },
        webSiteBilgileri: {SiteAdi: '', KatildigimIsler:[]},
        podCasts: [],
        duyurulars: [],
        frontend_address: process.env.VUE_APP_FRONTEND_ADDRESS
      }
    },
    apollo: {
      webSiteBilgileri: gql`
      query webSiteBilgileri {
        webSiteBilgileri {
          id
          SiteAdi
          tags
          PodCastAdi
          PodCastKonusu
          Slogan
          created_at
          updated_at
          KatildigimIsler {
            id
            Baslik
            KisaAciklama
            icon
            ArkaPlanResmi {
              url
              previewUrl
            }
            link
          }
        }
      }
    `,
      podCasts: gql`
       query podCasts {
        podCasts {
          id,
          Tarih,
          Adi,
          KisaAciklama,
          KapakResmi {
            url
          },
          PodCastDosyasi{
            url
          },
          Aciklama,
          Tags{
            Tag
          }
        }
       }
    `,
      duyurulars: gql`
       query duyurulars  {
          duyurulars{
            id
            Baslik
            Resim {
              url
            }
           }
        }
    `
    }
  }
</script>
<style>
</style>
